import React from 'react';
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import EditPermissionContext from 'contexts/EditPermissionContext';
import Permission from 'types/models/Permission';

import ListPermissionsPage from 'pages/private/admin/ListPermissionsPage';
import PermissionForm from 'forms/PermissionForm';
import EditPermissionPage from 'pages/private/admin/EditPermissionPage';

export default ({ match }: RouteComponentProps): JSX.Element => {
  const [selectedPermission, setSelectedPermission] = React.useState<Permission | null>(null);

  return (
    <EditPermissionContext.Provider value={{ selectedPermission, setSelectedPermission }}>
      <Switch>
        <Route exact={true} path={`${match.url}`} component={ListPermissionsPage} />
        <Route path={`${match.url}/create`} component={PermissionForm} />
        <Route path={`${match.url}/edit`} component={EditPermissionPage} />
        <Redirect to="/private/welcome" />
      </Switch>
    </EditPermissionContext.Provider>
  );
};
